import React from 'react'
import Layout from '../../../../components/Layout'
import Text from '../../../../components/Text'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'

import LiverForeverCarePlanLogo from '../../../../assets/images/care-plans/liver-forever-program/liver-forever-program-logo.png'
import { supportProgramTypes } from '../../../../constants/support-programs'
import ProgressBar from '../../../../components/Progressbar'
import PaidPlanBg from '../../../../assets/images/care-plans/paid-plan-bg.png'
import Lottie from 'react-lottie'
import * as liverLeafAnimationData from '../../../../assets/animations/liver-leaf.json'
import ArrowRightFilledIcon from '../../../../assets/icons/arrow-right-filled.svg'
import postMessageToRN from '../../../../utils/helpers/ReactNativeEvents'
import LiverForeverProgramJourneyImg from '../../../../assets/images/care-plans/liver-forever-program/liver-forver-program-post-purchase-journey.png'
import { getActivePatientPlan } from '../../../../utils/helpers/common'
import { useSelector } from 'react-redux'

const LiverForeverPlanAssignedPage = () => {
  const navigate = useNavigate()
  const supportProgram = supportProgramTypes['liver-forever-program']

  const { patientDetails } = useSelector((state) => state.auth)
  const patientPlan = getActivePatientPlan(patientDetails?.data?.patient_plans)

  const expiry_date = patientPlan?.plan_end_date // '2025-04-13'
  const start_date = patientPlan?.plan_start_date // '2025-04-14'

  const expiryDate = expiry_date ? moment(expiry_date, 'YYYY-MM-DD') : moment()
  const startDate = start_date ? moment(start_date, 'YYYY-MM-DD') : moment()
  const currentDate = moment()
  const isPlanExpired = expiryDate.isBefore(currentDate)

  // Calculate progress based on dates
  const totalDays = patientPlan
    ? Math.ceil(expiryDate.diff(startDate, 'days')) + 1
    : 0
  const elapsedDays = patientPlan
    ? Math.ceil(currentDate.diff(startDate, 'days')) + 1
    : 0
  const currentProgress = Math.min(elapsedDays, totalDays)

  const liverLeafAnimationOptions = {
    loop: true,
    autoplay: true,
    animationData: liverLeafAnimationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  const handleServicesClick = (service) => {
    console.log(service)
    postMessageToRN('NAVIGATE_BOOK_APPOINTMENT')
  }

  return (
    <Layout className="bg-white">
      <div className="min-w-sm max-w-lg relative mx-auto w-full h-screen overflow-y-auto">
        <div className="px-4 py-2 bg-[#EEF4FF]">
          <img
            src={LiverForeverCarePlanLogo}
            alt="Liver Forever Care Plan Logo"
            className="h-[48px]"
          />
        </div>

        <div className="bg-[#EEF4FF] relative pt-[127px] pb-6">
          <img
            src={PaidPlanBg}
            alt="liver-forever-care-plan-bg"
            className="absolute top-0 left-0 w-full h-full object-cover"
          />
          <div className="absolute top-[20px] left-0 right-0 z-0 mx-auto">
            <Lottie
              options={liverLeafAnimationOptions}
              height={120}
              width={200}
            />
          </div>
          <div className="z-10 bg-white rounded-xl p-4 mx-6 relative">
            <div className="flex flex-col gap-2 z-30">
              <Text variant="body" size="small" tag="p">
                Welcome To
              </Text>
              <Text variant="title" size="large" tag="p" bold={'true'}>
                {/* {supportProgram?.name} */}
                {patientPlan?.plan_name}
              </Text>
              <div>
                <ProgressBar current={currentProgress} total={totalDays} />
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 px-4">
          <Text variant="headline" size="large" tag="p" bold={'true'}>
            Your Services
          </Text>

          <div className="flex flex-col gap-4 mt-4">
            {supportProgramTypes['liver-forever-program'].services.map(
              (service) => (
                <button
                  key={service.id}
                  className="bg-white p-4 rounded-xl flex gap-4 relative"
                  onClick={() => {
                    handleServicesClick(service)
                  }}
                >
                  <img
                    src={service.icon}
                    alt={service.name}
                    className="w-9 h-9"
                  />
                  <div>
                    <Text
                      variant="body"
                      size="medium"
                      tag="p"
                      bold={'true'}
                      className={'mb-1'}
                    >
                      {service.name}
                    </Text>
                    <Text variant="body" size="small" tag="p">
                      {service.description}
                    </Text>
                  </div>
                  <img
                    src={ArrowRightFilledIcon}
                    alt={service.name}
                    className="w-5 h-5 absolute top-4 right-4"
                  />
                </button>
              ),
            )}
          </div>
        </div>

        <div className="pt-12">
          <img
            src={LiverForeverProgramJourneyImg}
            alt="Liver Forever Journey"
          />
        </div>
        {/* <Text variant="headline" size="small" tag="p" className="px-4 py-6">
          Your Chronic Care Program
        </Text>
        <div className="mx-6 relative pt-[150px]">
          <div className="flex justify-center">
            <img
              src={DocumentImg}
              className="w-[159px] h-[207px] absolute top-0 z-[1]"
              alt="liver-forever-care-plan"
            />
          </div>
          <div className="z-10 bg-white rounded-xl p-4 relative flex flex-col gap-3">
            <Text variant="title" size="large" tag="p" bold={'true'}>
              We are currently reviewing your documents
            </Text>
            <Text
              variant="body"
              size="medium"
              tag="p"
              className="text-[#5A6774] pb-2"
            >
              Documents are under review. This will take upto <b>24 hrs.</b>
            </Text>
            <Button
              fullWidth
              onClick={() =>
                navigate('/care-plans/liver-forever-program/preview')
              }
            >
              <img src={DocumentIcon} alt="document" />
              View Documents
            </Button>
          </div>
        </div>

        <img
          src={LiverForeverPorgramPosturchaseJourneyImg}
          alt="liver-forever-care-plan"
          className="pt-10"
          // className="absolute bottom-0 left-0"
        /> */}
      </div>
    </Layout>
  )
}

export default LiverForeverPlanAssignedPage
